module.exports = __webpack_public_path__ + "static/media/WorkingTogether.01fcde5e.jpg";